export const classes = {
  card: 'px-0 py-0 bg-transparent shadow-none',
  list: 'w-full py-0',
  toggle: 'mr-4',
  toggleOption: 'py-1',
};
